
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#2A333D"}},[_c('path',{attrs:{"d":"M16.5 19.286a2.786 2.786 0 110-5.571 2.786 2.786 0 010 5.57zm6.5-1.393v-2.786h-1.111c-.131-.51-.332-.99-.593-1.433l.785-.785-1.97-1.97-.785.785a5.514 5.514 0 00-1.433-.593V10h-2.786v1.111c-.51.131-.99.332-1.433.593l-.785-.785-1.97 1.97.785.785c-.261.442-.462.923-.593 1.433H10v2.786h1.111c.131.51.332.99.593 1.433l-.785.785 1.97 1.97.785-.786c.442.261.923.463 1.433.594V23h2.786v-1.11a5.55 5.55 0 001.433-.595l.785.787 1.97-1.97-.785-.786c.261-.442.462-.923.593-1.433H23z"}}),_c('path',{attrs:{"d":"M22 2v5H3.602v13.4H10V22H2V2h20zM9 3.7H8v1.6h1V3.7zm7 0h-1v1.6h1V3.7z"}}),_c('path',{attrs:{"d":"M5 9.1h3v1.6H5zM5 12.9h3v1.6H5zM5 16.7h3v1.6H5z"}})])])
          )
        }
      }
    